// @flow
import { useMemo } from 'react'
import { map, over, lensProp, replace } from 'ramda'

import { useCurrencySign } from 'app/common/components-next/currency'

export type HeaderCells = Array<{
  key: string,
  value: string,
  alignLeft?: boolean,
  alignRight?: boolean,
  alignCenter?: boolean,
}>

export const cells: HeaderCells = [
  {
    key: 'name',
    value: 'Наименование',
    alignLeft: true,
  },
  {
    key: 'title',
    value: 'Комплект',
    alignLeft: true,
  },
  {
    key: 'price',
    value: 'Цена,\u00A0%currency%',
    alignRight: true,
  },
  {
    key: 'number',
    value: 'Количество',
    alignRight: true,
  },
  {
    key: 'cost',
    value: 'Сумма,\u00A0%currency%',
    alignRight: true,
  },
  {
    key: 'sum',
    value: 'Итого,\u00A0%currency%',
    alignRight: true,
  },
]

export default function useHeaderCellsData(): HeaderCells {
  const currencySign = useCurrencySign()

  const cellsWithCurrencySign = useMemo(() => {
    return map(over(lensProp('value'), replace('%currency%', currencySign)), cells)
  }, [currencySign])

  return cellsWithCurrencySign
}
